export default __webpack_public_path__ + "static/media/Mets.c7eb9663.png";